import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contac';
import Pgvt from './pages/product/Slab'
import Floor from './pages/product/Floor'
import Wall from './pages/product/Wall'
import HighGloss from './pages/product/HighGloss'
import Elevation from './pages/product/Elevetion'
import Wooden from './pages/product/Wooden'
import TileVisualizer from './pages/TileVisualizer';
import Bathroom from './pages/category/Bathrrom';
import Kitchen from './pages/category/Kitchen';
import LeavingArea from './pages/category/LeavingArea';
import Bedroom from './pages/category/Bedroom';
import Commercial from './pages/category/CommercialSpace';
import Outdoor from './pages/category/OutDoor';
import CounterTops from './pages/category/CounterTops'
import StairsTils from './pages/category/StairsTils';
import Slab from './pages/product/Slab';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path='/floor' element={<Floor />} />
        <Route path='/porcelain-slab' element={<Slab />} />
        <Route path='/wall' element={<Wall />} />
        <Route path='/high-gloss' element={<HighGloss />} />
        <Route path='/elevation' element={<Elevation />} />
        <Route path='/wooden' element={<Wooden />} />
        <Route path='/tile-visualizer' element={<TileVisualizer />} />
        <Route path='/bathroom' element={<Bathroom />} />
        <Route path='kitchen' element={<Kitchen />} />
        <Route path='leaving-area' element={<LeavingArea />} />
        <Route path='bedroom' element={<Bedroom />} />
        <Route path='commercial-space' element={<Commercial />} />
        <Route path='outdoor' element={<Outdoor />} />
        <Route path='counter-tops' element={<CounterTops />} />
        <Route path='stairs-tils' element={<StairsTils />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;
